import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authApi } from '../api';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      session: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,

      setUser: (user) => set({ user, isAuthenticated: !!user }),

      setSession: (session) => set({ session }),

      login: async (credentials) => {
        set({ isLoading: true, error: null });
        try {
          const response = await authApi.login(credentials);
          const { user, token } = response.data;
          localStorage.setItem('token', token);
          set({ user, isAuthenticated: true, isLoading: false });
          return response.data;
        } catch (error) {
          set({ error: error.response?.data?.message || 'Login failed', isLoading: false });
          throw error;
        }
      },

      register: async (userData) => {
        set({ isLoading: true, error: null });
        try {
          const response = await authApi.register(userData);
          set({ isLoading: false });
          return response.data;
        } catch (error) {
          set({ error: error.response?.data?.message || 'Registration failed', isLoading: false });
          throw error;
        }
      },

      logout: async () => {
        try {
          await authApi.logout();
        } catch (error) {
          // Best-effort logout; still clear local state even if the API fails (expired token, network issues, etc.)
          // eslint-disable-next-line no-console
          console.warn('Logout error (ignored):', error?.response?.data || error?.message);
        } finally {
          localStorage.removeItem('token');
          localStorage.removeItem('session');
          set({ user: null, session: null, isAuthenticated: false });
        }
      },

      getSession: async () => {
        set({ isLoading: true });
        try {
          const response = await authApi.getSession();
          const { session, user } = response.data;
          set({ session, user, isAuthenticated: !!user, isLoading: false });
          return response.data;
        } catch (error) {
          set({ isLoading: false });
          throw error;
        }
      },

      updateProfile: async (data) => {
        set({ isLoading: true, error: null });
        try {
          const response = await authApi.updateProfile(data);
          set({ user: response.data.user, isLoading: false });
          return response.data;
        } catch (error) {
          set({ error: error.response?.data?.message || 'Update failed', isLoading: false });
          throw error;
        }
      },

      clearError: () => set({ error: null }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ user: state.user, isAuthenticated: state.isAuthenticated }),
    }
  )
);

export default useAuthStore;
